import styled from 'styled-components';
import { theme } from '../../../global';

export const RadioContainer = styled.div`
  .ant-radio-group {
    height: 42px;
    border-radius: ${theme.spacings.s16};
    border: 1px solid ${theme.colors.grey};
    display: flex;
    background: ${theme.colors.white};

    .ant-radio-button-wrapper {
      flex: 1;
      height: 42px;
      border: none;
      background: transparent;
      font-family: 'Montserrat';
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.4px;
      text-align: center;
      color: ${theme.colors.grey};
      position: relative;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      margin: 0;

      /* Растягиваем label на всю ширину и высоту */
      .ant-radio-button-label {
        width: 200px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;

        @media (max-width: 500px) {
            width: 170px;
          }
      }

      /* Скрываем нативный radio input */
      .ant-radio-button {
        display: none;
      }

      /* Скрываем все псевдоэлементы Ant Design */
      &::before {
        display: none !important;
      }

      &::after {
        display: none !important;
      }

      .ant-radio-button-inner {
        display: none;
      }

      /* Если только один элемент - полное скругление */
      &:only-child {
        border-radius: ${theme.spacings.s12};
        
        .ant-radio-button-label {
          border-radius: ${theme.spacings.s12};
        }
      }

      /* Если больше одного элемента */
      &:not(:only-child) {
        /* Первая кнопка - скругление слева */
        &:first-child {
          border-radius: ${theme.spacings.s12} 0 0 ${theme.spacings.s12};
          
          .ant-radio-button-label {
            border-radius: ${theme.spacings.s12} 0 0 ${theme.spacings.s12};
          }
        }

        /* Последняя кнопка - скругление справа */
        &:last-child {
          border-radius: 0 ${theme.spacings.s12} ${theme.spacings.s12} 0;
          
          .ant-radio-button-label {
            border-radius: 0 ${theme.spacings.s12} ${theme.spacings.s12} 0;
          }
        }

        /* Все центральные кнопки (не первая и не последняя) - без скруглений */
        &:not(:first-child):not(:last-child) {
          border-radius: 0;
          
          .ant-radio-button-label {
            border-radius: 0;
          }
        }
      }

      &.ant-radio-button-wrapper-checked {
        background: transparent;
        color: ${theme.colors.white};
        
        .ant-radio-button-label {
          background: ${theme.colors.grey};
          color: ${theme.colors.white};
          font-weight: 600;
        }

        box-shadow: none;
        border: none;
      }

      &:not(.ant-radio-button-wrapper-checked) {
        border: none;
        box-shadow: none;
        
        .ant-radio-button-label {
          background: transparent;
          font-weight: 600;
        }
      }

      &:hover {
        color: ${theme.colors.grey};
        
        .ant-radio-button-label {
          color: ${theme.colors.grey};
          font-weight: 600;
        }
      }

      &.ant-radio-button-wrapper-checked:hover {
        .ant-radio-button-label {
          color: ${theme.colors.white};
          background: ${theme.colors.grey};
          font-weight: 600;
        }
      }
    }
  }
`;
